import { EditorContextType } from "@/types/editor";
import { createContext } from "react";

export const EditorContext = createContext<EditorContextType | null>(null);
